/*
 * LICENSE PROTECTED SOFTWARE
 *
 * Bu yazilim lisans korumasi altindadir.
 * Gecerli lisans olmadan kullanilmasi yasaktir.
 *
 * Kaynak kodunun izinsiz erisimi, kopyalanmasi veya dagitimi
 * hukuki yaptirimslara tabidir.
 * (c) 2026  @cemdemirci0101
 *  bilgi@cemdemirci.com
 * This source code is proprietary and confidential.
 * Unauthorized copying, modification, or distribution
 * of this file, via any medium, is strictly prohibited.
 * (c) 2026 All Rights Reserved.
 */

import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatRelativeTime(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "Az önce";
  if (diffMins < 60) return `${diffMins} dakika önce`;
  if (diffHours < 24) return `${diffHours} saat önce`;
  if (diffDays < 7) return `${diffDays} gün önce`;
  return formatDate(dateString);
}

export const TICKET_STATUS = {
  yeni: { label: "Yeni", color: "default" },
  inceleniyor: { label: "İnceleniyor", color: "info" },
  yonlendirildi: { label: "Yönlendirildi", color: "info" },
  islemde: { label: "İşlemde", color: "warning" },
  yanit_bekleniyor: { label: "Vatandaş Yanıt Bekleniyor", color: "warning" },
  cozuldu: { label: "Çözüldü", color: "success" },
  kapatildi: { label: "Kapatıldı", color: "default" },
  beklemede: { label: "Beklemede", color: "warning" },
  iptal: { label: "İptal", color: "error" },
};

export const TICKET_TYPES = {
  talep: { label: "Talep", color: "info" },
  sikayet: { label: "Şikayet", color: "warning" },
  oneri: { label: "Öneri", color: "success" },
  proje: { label: "Proje Önerisi", color: "purple" },
};

export const TICKET_PRIORITY = {
  dusuk: { label: "Düşük", color: "default" },
  normal: { label: "Normal", color: "info" },
  yuksek: { label: "Yüksek", color: "warning" },
  acil: { label: "Acil", color: "error" },
};

export const PROJECT_CATEGORIES = [
  { value: "cevre", label: "Çevre" },
  { value: "ulasim", label: "Ulaşım" },
  { value: "sosyal_yardim", label: "Sosyal Yardım" },
  { value: "kultur_sanat", label: "Kültür-Sanat" },
  { value: "egitim", label: "Eğitim" },
  { value: "saglik", label: "Sağlık" },
  { value: "spor", label: "Spor" },
  { value: "kent_tasarimi", label: "Kent Tasarımı" },
  { value: "engelli_haklari", label: "Engelli Hakları" },
  { value: "kadin_haklari", label: "Kadın Hakları" },
  { value: "genclik", label: "Gençlik" },
  { value: "teknoloji", label: "Teknoloji" },
  { value: "diger", label: "Diğer" },
];

export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'image/jpeg',
  'image/png',
];

export const USER_ROLES = {
  admin: { label: "Sistem Yöneticisi", color: "error" },
  kent_konseyi_baskani: { label: "Kent Konseyi Başkanı", color: "warning" },
  genel_sekreter: { label: "Genel Sekreter", color: "warning" },
  genel_sekreter_yardimcisi: { label: "Genel Sekreter Yardımcısı", color: "warning" },
  meclis_baskani: { label: "Meclis Başkanı", color: "info" },
  cg_baskani: { label: "Çalışma Grubu Başkanı", color: "info" },
  yk_uyesi: { label: "Yürütme Kurulu Üyesi", color: "info" },
  muhtar: { label: "Muhtar", color: "info" },
  stk: { label: "STK", color: "success" },
  vatandas: { label: "Vatandaş", color: "default" },
};

export const STK_STATUS = {
  taslak: { label: "Taslak", color: "default" },
  inceleniyor: { label: "İnceleniyor", color: "info" },
  eksik_belge: { label: "Eksik Belge", color: "warning" },
  onaylandi: { label: "Onaylandı", color: "success" },
  reddedildi: { label: "Reddedildi", color: "error" },
};

// STK Kurum Türleri - Tüm STK kayıt/başvuru ekranlarında kullanılır
export const STK_KURUM_TURLERI = [
  { value: "dernek", label: "Dernek" },
  { value: "vakif", label: "Vakıf" },
  { value: "kooperatif", label: "Kooperatif" },
  { value: "sendika", label: "Sendika" },
  { value: "oda", label: "Oda" },
  { value: "birlik", label: "Birlik" },
  { value: "platform", label: "Platform" },
  { value: "siyasi_parti", label: "Siyasi Parti" },
  { value: "federasyon", label: "Federasyon" },
  { value: "konfederasyon", label: "Konfederasyon" },
  { value: "diger", label: "Diğer" },
];

// value → label hızlı erişim haritası
export const STK_KURUM_TURU_LABELS = STK_KURUM_TURLERI.reduce(
  (acc, t) => { acc[t.value] = t.label; return acc; }, {}
);

export const MEETING_TYPES = {
  genel_kurul: { label: "Genel Kurul", color: "warning" },
  yurutme_kurulu: { label: "Yürütme Kurulu", color: "info" },
  meclis: { label: "Meclis Toplantısı", color: "success" },
  calisma_grubu: { label: "Çalışma Grubu", color: "default" },
  diger: { label: "Diğer", color: "default" },
};

export const TARGET_AUDIENCES = [
  { value: "tum_kullanicilar", label: "Tum Kullanicilar" },
  { value: "vatandaslar", label: "Vatandaslar" },
  { value: "stklar", label: "STK'lar" },
  { value: "muhtarlar", label: "Muhtarlar" },
  { value: "meclisler", label: "Meclisler" },
  { value: "calisma_gruplari", label: "Calisma Gruplari" },
  { value: "yurutme_kurulu", label: "Yurutme Kurulu" },
  { value: "genel_kurul", label: "Genel Kurul" },
  { value: "genel_sekreter", label: "Genel Sekreter" },
  { value: "kent_konseyi_baskani", label: "Kent Konseyi Baskani" },
];

export const KENT_KONSEYI_ANA_KADEME = ["yurutme_kurulu", "genel_sekreter", "kent_konseyi_baskani"];

export const WG_APPLICATION_STATUS = {
  beklemede: { label: "Beklemede", color: "warning" },
  onaylandi: { label: "Onaylandı", color: "success" },
  reddedildi: { label: "Reddedildi", color: "error" },
  ayrildi: { label: "Ayrıldı", color: "default" },
};
